import getApiClient from 'src/utils/getApiClient'
import type { LpuScheduleResponse } from 'src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/api/apiLpuSchedule.types'

const apiClient = getApiClient()

const apiLpuSchedule = {
  get(addressId: number) {
    return apiClient.get<LpuScheduleResponse>('/ajax/schedule/', {
      params: {
        address: addressId,
      },
    })
  },
}

export default apiLpuSchedule
